import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type PageHeaderProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
};

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div
      className={cn(
        'relative mb-8 flex flex-col gap-5 pb-8 sm:flex-row sm:items-start sm:justify-between',
        className
      )}
    >
      <div
        className="pointer-events-none absolute -left-4 -top-1 h-24 w-24 rounded-full bg-teal-400/10 blur-2xl sm:-left-6"
        aria-hidden
      />
      <div className="relative min-w-0 space-y-2.5">
        <p className="inline-flex items-center rounded-full border border-teal-200/70 bg-gradient-to-r from-teal-50/95 to-emerald-50/40 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-teal-800/90 shadow-sm shadow-teal-900/5">
          贴图虾
        </p>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
        {description ? (
          <p className="max-w-3xl text-sm leading-relaxed text-slate-600 max-sm:text-[13px]">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="relative flex w-full shrink-0 flex-col gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-2">
          {actions}
        </div>
      ) : null}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-teal-500/35 via-slate-200/70 to-transparent" aria-hidden />
      <div
        className="absolute -bottom-px left-0 h-px w-1/3 max-w-md bg-gradient-to-r from-teal-400/50 to-transparent blur-[1px]"
        aria-hidden
      />
    </div>
  );
}
